import AccountComponent from '@/components/api/AccountComponent'
import {sessionName, setSessionWithCrypto} from "@/utils/Session"
import {handleApiError} from "@/utils/VuexUtil";

const MODULE_NAME = 'account'

const state = {
    currentUser: null,
}

export const AccountActionTypeEnum = {
    getCurrentUser: '['+MODULE_NAME+'] getCurrentUser',
};

const MutationTypeEnum = {
    getCurrentUserStart: '['+MODULE_NAME+'] getCurrentUserStart',
    getCurrentUserSuccess: '['+MODULE_NAME+'] getCurrentUserSuccess',
    getCurrentUserFailure: '['+MODULE_NAME+'] getCurrentUserFailure',
};

const getters = {
    getCurrentUser: state => state.currentUser,
}

const mutations = {
    [MutationTypeEnum.getCurrentUserStart](state) {
        state.isLoading = true;
        state.errors = null;
    },
    [MutationTypeEnum.getCurrentUserSuccess](state, response) {
        state.isLoading = false;
        if (response.status === 200) {
            state.currentUser = response.data.result;
        }
    },
    [MutationTypeEnum.getCurrentUserFailure](state, response) {
        state.isLoading = false;
        if (response) state.errors = response.errors;
        state.currentUser = null;
    }
}

const actions = {
    async [AccountActionTypeEnum.getCurrentUser](context, credentials) {
        context.commit(MutationTypeEnum.getCurrentUserStart);
        try {
            const response = await AccountComponent.get(credentials);
            context.commit(MutationTypeEnum.getCurrentUserSuccess, response);

            if (response.status === 200) {
                await setSessionWithCrypto(sessionName.CURRENT_USER, response.data.result)
            }

            return response;
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.getCurrentUserFailure, formattedError);
            return formattedError;
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
};